module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cals box cals-classes",
    class: _vm.step.uniClass
  }, [(_vm.isOnboarding) ? _c('div', {
    staticClass: "onboard-pill"
  }, [_c('span', {
    staticClass: "onboard-pill__status",
    class: {
      'onboard-pill__status__done': _vm.step.done
    }
  }, [(_vm.step.done) ? _c('span', {
    staticClass: "icon-checkmark4 js-setupWidgetEvent"
  }) : _vm._e()]), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.step')) + " " + _vm._s(_vm.step.stepNum) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.step.icon) ? _c('span', {
    staticClass: "cals_icon",
    class: _vm.step.icon
  }) : _vm._e(), _vm._v(" "), (_vm.step.stepNum < 6 && _vm.isLoading) ? _c('spinner', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "color": "blue",
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.step.number >= 0 && !_vm.isLoading) ? _c('h6', [_vm._v(_vm._s(_vm.step.number))]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.step.title))]), _vm._v(" "), (_vm.step.desc && _vm.isOnboarding) ? _c('p', {
    staticClass: "step-desc"
  }, [_vm._v(_vm._s(_vm.step.desc))]) : _vm._e(), _vm._v(" "), (!_vm.isOnboarding) ? [(_vm.step.buttonText) ? _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.step.action
    }
  }, [_vm._v("\n      " + _vm._s(_vm.step.buttonText) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isSchoolFromNorway) ? _c('button', {
    staticClass: "bttn bttn-simple youtube-popup",
    on: {
      "click": function($event) {
        return _vm.seeTutorial(_vm.step)
      }
    }
  }, [_c('span', {
    staticClass: "icon-play3"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.dashboard.tutorial')) + " (" + _vm._s(_vm.step.guideDuration) + ")\n    ")]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-873e152a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/School/DashboardBox.vue
// module id = 2051
// module chunks = 1